<template>
    <div class="card-ticket">
        <div class="row">
            <div class="xs12 pa-3 pb-2">
                <div :class="rowText">
                    <div class="mr-2">
                        <i class="mdi mdi-account-outline"></i>
                    </div>
                    <div :class="textRight">
                        {{ item.HoTen ? item.HoTen : "" }}
                    </div>
                    <span> -</span>
                    <div :class="textRight">
                        CCCD: {{ item.SoCMND ? item.SoCMND : "" }}
                    </div>
                </div>
                <div :class="rowText">
                    <div class="mr-2">
                        <i class="mdi mdi-cellphone-information"></i>
                    </div>
                    <div :class="textRight">
                        {{ item.SoDienThoai ? item.SoDienThoai : "" }}
                    </div>
                </div>
                <div :class="rowText">
                    <div class="mr-2">
                        <i class="mdi mdi-card-account-details-outline"></i>
                    </div>
                    <div :class="textRight">
                        {{ item.SoGPLX ? item.SoGPLX : "" }}
                    </div>
                    <span> -</span>
                    <div :class="textRight">
                        Hạng: {{ item.HangGPLX ? item.HangGPLX : "" }}
                    </div>
                </div>
                <div :class="rowText">
                    <div class="mr-2">
                        <i class="mdi mdi-calendar-clock"></i>
                    </div>
                    <div :class="textRight">
                        {{ item.HanGPLX ? $Helper.Common.formatDate(item.HanGPLX) : "" }}
                    </div>
                </div>
                <div :class="rowLastText">
                    <div class="mr-2">
                        <i class="mdi mdi-list-status"></i>
                    </div>
                    <div :class="textRight">
                        <span :style="`color: ${item.MaMauTrangThaiTaiKhoan}`">
                            {{ `${item.TrangThaiTaiKhoan} - ` }}
                        </span>
                        <span :style="`color: ${item.MaMauTrangThai}`">
                            {{ item.TrangThai }}
                        </span>
                        <span :class="`${item.IsDelete ? `color-error` : ``}`">
                            {{ item.IsDelete ? " - Đã xóa" : "" }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="xs12">
                <div class="row" style="border-top: 1px solid #dadce0; padding: 0 2px">
                    <div
                        class="xs6 text-xs-center"
                        style="border-right: 1px solid #dadce0"
                    >
                        <DxButton
                            :disabled="
                                item.IsDelete ||
                                !$Helper.KiemTraQuyen(
                                    $t('QuyenLenhDienTu.LENHDIENTU'),
                                    $t('QuyenLenhDienTu.XoaLaiXe'),
                                )
                            "
                            text="Xóa"
                            type="danger"
                            styling-mode="text"
                            width="100%"
                            @click="XoaLaiXe"
                        />
                    </div>
                    <div class="xs6 text-xs-center">
                        <DxButton
                            :disabled="item.IsDelete"
                            text="Sửa"
                            type="default"
                            styling-mode="text"
                            width="100%"
                            @click="
                                $router.push({
                                    path: '/Thong-Tin-Lai-Xe',
                                    query: { IdLaiXe: item.IdLaiXe },
                                })
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!item.MaMauTrangThaiChuyenDiVDT == '#13B000'">
            <div class="xs12">
                <div class="row" style="border-top: 1px solid #dadce0; padding: 0 2px">
                    <div class="xs12 text-xs-center">
                        <DxButton
                            text="Tạo chuyến đi bán vé"
                            type="default"
                            styling-mode="text"
                            width="100%"
                            @click="TaoChuyenDiBanVe(item)"
                            class="color-primary"
                            :disabled="
                                item.MaMauTrangThaiChuyenDiVDT == '#13B000' ? true : false
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Xác nhận cập nhật thông tin -->
    <PopupVue
        height="auto"
        v-if="ifPopupXacNhanXoa"
        v-model:dialog="PopupXacNhanXoa"
        title=""
        buttonTextLeft="Hủy"
        buttonTextRight="Đồng ý"
        class="popup-padding-8"
        @close="XacNhanXoa"
        heightScrollView="auto"
    >
        <template #content>
            <ThongBaoVue
                :message="ParamThongBao.message"
                :state="ParamThongBao.state"
                :title="ParamThongBao.title"
            />
        </template>
    </PopupVue>
</template>

<script>
import { DxButton } from "devextreme-vue";
import ThongBaoVue from "../../../../components/_Common/ThongBao.vue";
import PopupVue from "../../../../components/_Common/Popup.vue";
export default {
    components: {
        DxButton,
        ThongBaoVue,
        PopupVue,
    },
    props: {
        item: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            rowText: "row mb-1 align-center row-text",
            rowLastText: "row align-center row-text",
            textRight: " font-medium",
            ifPopupXacNhanXoa: false,
            PopupXacNhanXoa: false,
            IdLaiXe: null,
            ParamThongBao: {
                state: "Warning",
                title: "Bạn có chắc chắn xóa lái xe đã chọn?",
                message: "",
            },
        };
    },
    computed: {},
    watch: {
        PopupDanhSachChucNang() {
            if (!this.PopupDanhSachChucNang) {
                this.NgatDOMPopup("ifPopupDanhSachChucNang");
            }
        },
    },
    methods: {
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        NgatDOMPopup(key) {
            setTimeout(() => {
                this[key] = false;
            }, 300);
        },
        XoaLaiXe() {
            this.IdLaiXe = this.item.IdLaiXe + "";
            this.showPopup("PopupXacNhanXoa");
        },
        XacNhanXoa(bool) {
            if (bool == false) {
                this.PopupXacNhanXoa = false;
            } else if (bool == true) {
                this.PopupXacNhanXoa = false;
                this.ThucHienXoaLaiXe();
            }
        },
        async ThucHienXoaLaiXe() {
            try {
                let rs = await this.$store.dispatch("ThongTinLaiXe/XoaLaiXe", this.IdLaiXe);
                this.PopupXacNhanXoa = false;
                if (rs.status == true) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        `Xóa thông tin lái xe thành công!`,
                    );
                    this.$emit("getData");
                } else if (rs.status == false) {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Xóa thông tin lái xe thất bại!",
                        message: rs.message,
                    });
                }
            } catch (ex) {
                this.PopupXacNhanXoa = false;
                this.$Helper.ThongBaoPopup({
                    message_title: "Xóa thông tin lái xe thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            }
        },
    },
};
</script>

<style scoped>
.card-ticket {
    position: relative;
    box-shadow: 0px 2px 9px #ccc;
    overflow: hidden;
}
.row-text {
    word-break: break-word;
    white-space: break-spaces;
}
:deep(.custom-action-sheet .dx-toolbar-label div) {
    font-size: 20px;
    font-weight: 500;
}
</style>
